import { createFileRoute, notFound } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';

import { EmailNotFoundPanel } from '../-components/empty-states';
import { FolderEmailPanel } from '../-components/thread-panel';
import type { Id } from '@minty/shared/ids';
import { DetailsLoading } from '~/components/list-panel-states';
import { useTRPC } from '~/lib/trpc';

export const Route = createFileRoute('/_dashboard/mailbox/$folder/$emailId')({
  pendingComponent: DetailsLoading,
  notFoundComponent: EmailNotFoundPanel,
  component: FolderEmailRoute,
});

function FolderEmailRoute() {
  const trpc = useTRPC();
  const { emailId, folder } = Route.useParams();
  const navigate = Route.useNavigate();
  // Spam and trash detail is a single message, not a conversation.
  const { data: email } = useSuspenseQuery(
    trpc.emails.views.getFolderEmail.queryOptions({
      emailId: emailId as Id<'emails'>,
      folder,
    }),
  );

  if (email === null) {
    throw notFound();
  }

  return (
    <FolderEmailPanel
      key={emailId}
      folder={folder}
      email={email}
      onMoved={() =>
        void navigate({
          to: '/mailbox/$folder',
          params: { folder },
          search: true,
        })
      }
    />
  );
}
